import useFeatureFlag from 'hooks/Optimizely/useFeatureFlag'
import { OptimizelyFeatureFlags } from 'constants/optimizely'

export const useRewardSeatsEnabled = () => useFeatureFlag(OptimizelyFeatureFlags.maldivesCharterRewardSeats)
